import { useEffect, useState } from 'react';
import { Event, Page } from '@/config/track-config';
import { useStakingStore } from '@/store/staking';
import { FaqItem } from '@/types/staking';
import { useFm } from '@web3/base-hooks';
import cls from 'classnames';

import styles from './index.module.scss';

import LineIcon from '@/assets/icons/home/line-arrow.svg';
import ArrowIcon from '~/public/svg/home/arrow.svg';

interface IProps {
  helpCenterUrl: string;
}

export const Faq = ({ helpCenterUrl }: IProps) => {
  const fm = useFm();
  const {
    configLoading,
    homeConfig: { faqList = [] },
  } = useStakingStore();
  const [currentTitle, setCurrentTitle] = useState<string>('');

  const handleArrowClick = (subject: string) => {
    if (currentTitle === subject) return;
    setCurrentTitle(subject);
  };

  useEffect(() => {
    if (!currentTitle && faqList?.length) {
      setCurrentTitle(faqList[0].subject);
    }
  }, [faqList, currentTitle]);

  if (!configLoading && !faqList?.length) return <></>;

  return (
    <div className={styles.container}>
      <h2 className={cls('flex items-center', styles.title)}>
        {fm('faqs')}
        <a
          href={helpCenterUrl}
          target="__blank"
          rel="noopener noreferrer"
          data-spm-even={Event.Web3UserClick}
          data-spm-data={JSON.stringify({
            page_name: Page.StakingWebHomepage,
            button_name: 'Earn_morefaq',
          })}
        >
          <ArrowIcon className={styles.pixelArrow} />
        </a>
      </h2>
      <div className={styles.contentBg}>
        {faqList?.map((item: FaqItem) => {
          const { content, subject } = item;
          return (
            <div key={subject} className={cls('cursor-pointer', styles.box)}>
              <h2
                className={cls(
                  'flex justify-between items-center',
                  styles.titleBg
                )}
                onClick={() => handleArrowClick(subject)}
              >
                <span className={styles.subject}>{subject}</span>
                <LineIcon
                  className={cls('object-cover', styles.arrow, {
                    [styles.arrowUp]: currentTitle === subject,
                  })}
                  style={{
                    height: 24,
                    width: 24,
                  }}
                />
              </h2>
              <p
                className={cls(styles.content, {
                  [styles.contentVisible]: currentTitle === subject,
                })}
              >
                {content.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n')}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
